import { LOAD_COMPROMISSOS, PDG_TOGGLE_LOADING, SET_COMPROMISSOS_SECRETARIA, SET_LOADING_SECRETARIA } from './types'
import { request } from '../../../request'

export const actions = {
  async loadCompromissosAno(store, payload) {
    store.commit(PDG_TOGGLE_LOADING, true)

    try {
      const { data } = await request.get('/planodegoverno', {
        params: {
          periodo: payload,
        }
      })
      store.commit(LOAD_COMPROMISSOS, data)
    } catch (err) {
      console.error('Erro ao carregar compromissos:', err)
      store.commit(LOAD_COMPROMISSOS, [])
    } finally {
      store.commit(PDG_TOGGLE_LOADING, false);
    }
  },
  async loadCompromissosSecretaria({ commit }, payload) {
    commit(SET_LOADING_SECRETARIA, true);

    try {
      const { data } = await request.get('/planodegoverno', {
        params: {
          periodo: payload.periodo,
          unidade_executora: payload.secretariaId
        }
      });
      commit(SET_COMPROMISSOS_SECRETARIA, data);
    } catch (err) {
      console.error('Erro ao carregar compromissos da secretaria:', err);
      commit(SET_COMPROMISSOS_SECRETARIA, []);
    } finally {
      commit(SET_LOADING_SECRETARIA, false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/plano_governo/actions.js